import React from 'react' 
import { BackItemSVG } from '../../asset/icon/BackItemSVG'
import { CustomerInfoSVG } from '../../asset/icon/CustomerInfoSVG'
import { InfoBlackSvg } from '../../asset/icon/InfoBlackSvg'
import { OrientationView } from '../StandartComponent/OrientationView/OrientationView'
//@ts-ignore
import s from './MainView.module.scss'
import { useDispatch } from 'react-redux'
import { setMainStep, setModalSwitching } from '../../store/actions/setting' 
import { PlayerThreeKit } from '../PlayerThreeKit/PlayerThreeKit'
import { ViewPlan } from '../ViewPlan/ViewPlan' 
import { SwitchStandardBase } from '../BaseComponent/SwitchStandardBase/SwitchStandardBase'

export const MainView = () => {
    const dispatch = useDispatch()

    const onCustomInfo = () => {
        dispatch(setMainStep('CustomerInfo'))
    }

    const onPriceInfo = () => {
        dispatch(setModalSwitching({ idModal: 'visiblePrice', conditionModal: true }))
    }
    const onSaveConfig = () => {
        dispatch(setModalSwitching({ idModal: 'visibleSaveConfig', conditionModal: true }))
    }


    return (
        <>
            <div className={s.topHeader}>
                <div className={s.section_left}>
                    <div className={`${s.btn} ${s.btn_back} `}>
                        <div className={s.icon}><BackItemSVG /></div>
                        <div className={s.name}>Back</div>
                    </div>
                    <div className={s.title}>The Texan</div>
                    <div className={s.price}>$17,596.48</div>
                    <div className={s.info} onClick={() => onPriceInfo()} ><InfoBlackSvg /></div>

                </div>
                <div className={s.section_right}>
                    <div className={s.btn_customUser} onClick={onCustomInfo} >
                        <div className={s.icon}><CustomerInfoSVG /></div>
                        <div className={s.name}>Customer Info</div>
                    </div>

                    <div className={s.wrapBtn}>
                        <div className={`${s.btn} ${s.btn_save}`} onClick={() => onSaveConfig()}> Save Your quote </div>
                        <div className={`${s.btn} ${s.btn_submit_order}`}> Submit order </div>
                    </div>
                </div>
            </div>
            <div className={s.view}>
                <div className={s.config}>
                    <PlayerThreeKit />
                </div>


                <ViewPlan />
            </div>
            <div className={s.footer}>
                <div className={s.switch}>
                    <SwitchStandardBase label='Dimensions' onChange={() => console.log('test')} /> 
                </div>
                <OrientationView />
            </div>
        </>
    )
}
